import { MigrationInterface, QueryRunner } from 'typeorm'

import { Kpi, KpiPeriodType } from '../service/kpi/kpi'
import { KpiStatistic } from '../service/kpi-statistic/kpi-statistic'
import { Domain, getRepository } from '@things-factory/shell'

const KPI_STATISTICS = [
  // X11 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X11. 연면적 대비 공사기간',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 100,
    sum: 153.5945,
    range: 10.775829,
    mean: 1.535945,
    median: 0.596117,
    minimum: 0.096101,
    maximum: 10.87193,
    standardDeviation: 2.123456,
    variance: 4.509123,
    percentile25: 0.16328,
    percentile75: 1.987095,
    iqr: 1.823815,
    lowerFence: -2.57244,
    upperFence: 4.722817,
    additionalStatistics: {
      coefficientOfVariation: 1.382,
      skewness: 2.145,
      kurtosis: 8.234
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 100,
      source: 'production_line_x11'
    }
  },
  // X12 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X12. 설계변경에 따른 공기 증감률',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 95,
    sum: 2.83898,
    range: 0.73448,
    mean: 0.029884,
    median: -0.00059,
    minimum: -0.03448,
    maximum: 0.7,
    standardDeviation: 0.123456,
    variance: 0.015241,
    percentile25: -0.02499,
    percentile75: 0.053692,
    iqr: 0.078682,
    lowerFence: -0.14302,
    upperFence: 0.17172,
    additionalStatistics: {
      coefficientOfVariation: 4.132,
      skewness: 3.456,
      kurtosis: 12.789
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 95,
      source: 'production_line_x12'
    }
  },
  // X13 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X13. 일정 이탈 수준',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 88,
    sum: 407.1584,
    range: 1.0,
    mean: 4.6268,
    median: 5.0,
    minimum: 4.0,
    maximum: 5.0,
    standardDeviation: 0.234567,
    variance: 0.055021,
    percentile25: 4.0,
    percentile75: 5.0,
    iqr: 1.0,
    lowerFence: 2.5,
    upperFence: 6.5,
    additionalStatistics: {
      coefficientOfVariation: 0.051,
      skewness: -0.234,
      kurtosis: 2.456
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 88,
      source: 'production_line_x13'
    }
  },
  // X14 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X14. 일정성과 수준 평가',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 92,
    sum: 368.253,
    range: 2.0,
    mean: 4.00275,
    median: 4.0,
    minimum: 3.0,
    maximum: 5.0,
    standardDeviation: 0.345678,
    variance: 0.119493,
    percentile25: 3.0,
    percentile75: 5.0,
    iqr: 2.0,
    lowerFence: 0.0,
    upperFence: 8.0,
    additionalStatistics: {
      coefficientOfVariation: 0.086,
      skewness: 0.123,
      kurtosis: 2.789
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 92,
      source: 'production_line_x14'
    }
  },
  // X21 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X21. 연면적 대비 공사비',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 85,
    sum: 2.99642,
    range: 0.312186,
    mean: 0.035252,
    median: 0.014745,
    minimum: 0.006322,
    maximum: 0.318508,
    standardDeviation: 0.045678,
    variance: 0.002086,
    percentile25: 0.007259,
    percentile75: 0.042295,
    iqr: 0.035036,
    lowerFence: -0.04529,
    upperFence: 0.094849,
    additionalStatistics: {
      coefficientOfVariation: 1.296,
      skewness: 2.345,
      kurtosis: 7.234
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 85,
      source: 'production_line_x21'
    }
  },
  // X22 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X22. 설계변경에 따른 공사비 증감률',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 87,
    sum: 3.803265,
    range: 0.2023,
    mean: 0.043715,
    median: 0.021246,
    minimum: -0.0053,
    maximum: 0.197,
    standardDeviation: 0.034567,
    variance: 0.001195,
    percentile25: -0.00062,
    percentile75: 0.073369,
    iqr: 0.073989,
    lowerFence: -0.1116,
    upperFence: 0.184352,
    additionalStatistics: {
      coefficientOfVariation: 0.791,
      skewness: 1.567,
      kurtosis: 5.123
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 87,
      source: 'production_line_x22'
    }
  },
  // X23 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X23. 비용성과 수준 평가',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 90,
    sum: 279.5535,
    range: 4.0,
    mean: 3.10615,
    median: 3.0,
    minimum: 1.0,
    maximum: 5.0,
    standardDeviation: 0.456789,
    variance: 0.208656,
    percentile25: 2.0,
    percentile75: 4.0,
    iqr: 2.0,
    lowerFence: -1.0,
    upperFence: 7.0,
    additionalStatistics: {
      coefficientOfVariation: 0.147,
      skewness: 0.234,
      kurtosis: 2.567
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 90,
      source: 'production_line_x23'
    }
  },
  // X31 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X31. 품질시험 불합격률',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 93,
    sum: 26.617623,
    range: 1.8882,
    mean: 0.286211,
    median: 0.108761,
    minimum: 0.0018,
    maximum: 1.89,
    standardDeviation: 0.345678,
    variance: 0.119493,
    percentile25: 0.017687,
    percentile75: 0.393518,
    iqr: 0.375831,
    lowerFence: -0.54606,
    upperFence: 0.957264,
    additionalStatistics: {
      coefficientOfVariation: 1.208,
      skewness: 2.123,
      kurtosis: 6.789
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 93,
      source: 'production_line_x31'
    }
  },
  // X32 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X32. 검수자재 불합격률',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 89,
    sum: 9.519796,
    range: 1.191035,
    mean: 0.106964,
    median: 0.035077,
    minimum: 0.008965,
    maximum: 1.2,
    standardDeviation: 0.234567,
    variance: 0.055021,
    percentile25: 0.011285,
    percentile75: 0.124878,
    iqr: 0.113593,
    lowerFence: -0.15911,
    upperFence: 0.295269,
    additionalStatistics: {
      coefficientOfVariation: 2.193,
      skewness: 3.456,
      kurtosis: 12.345
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 89,
      source: 'production_line_x32'
    }
  },
  // X33 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X33. 검측 불합격률',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 91,
    sum: 8.855573,
    range: 1.0,
    mean: 0.097303,
    median: 0.03431,
    minimum: 0.0,
    maximum: 1.0,
    standardDeviation: 0.123456,
    variance: 0.015241,
    percentile25: 0.0052,
    percentile75: 0.128793,
    iqr: 0.123593,
    lowerFence: -0.18019,
    upperFence: 0.314182,
    additionalStatistics: {
      coefficientOfVariation: 1.269,
      skewness: 2.789,
      kurtosis: 8.567
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 91,
      source: 'production_line_x33'
    }
  },
  // X34 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X34. 품질 SL-PA 결과값',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 94,
    sum: 456.229,
    range: 0.0,
    mean: 4.8535,
    median: 5.0,
    minimum: 5.0,
    maximum: 5.0,
    standardDeviation: 0.0,
    variance: 0.0,
    percentile25: 5.0,
    percentile75: 5.0,
    iqr: 0.0,
    lowerFence: 2.5,
    upperFence: 5.0,
    additionalStatistics: {
      coefficientOfVariation: 0.0,
      skewness: 0.0,
      kurtosis: 0.0
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 94,
      source: 'production_line_x34'
    }
  },
  // X35 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X35. 품질성과 수준 평가',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 96,
    sum: 437.352,
    range: 0.0,
    mean: 4.55575,
    median: 5.0,
    minimum: 5.0,
    maximum: 5.0,
    standardDeviation: 0.0,
    variance: 0.0,
    percentile25: 5.0,
    percentile75: 5.0,
    iqr: 0.0,
    lowerFence: 2.5,
    upperFence: 6.5,
    additionalStatistics: {
      coefficientOfVariation: 0.0,
      skewness: 0.0,
      kurtosis: 0.0
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 96,
      source: 'production_line_x35'
    }
  },
  // X41 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X41. 재해율',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 88,
    sum: 0.59576,
    range: 0.08913,
    mean: 0.00677,
    median: 0.003161,
    minimum: 0.0,
    maximum: 0.08913,
    standardDeviation: 0.012345,
    variance: 0.000152,
    percentile25: 0.000873,
    percentile75: 0.008789,
    iqr: 0.007916,
    lowerFence: -0.011,
    upperFence: 0.020662,
    additionalStatistics: {
      coefficientOfVariation: 1.824,
      skewness: 3.234,
      kurtosis: 11.567
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 88,
      source: 'production_line_x41'
    }
  },
  // X42 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X42. 재해강도율',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 86,
    sum: 0.33411,
    range: 0.021877,
    mean: 0.003885,
    median: 0.000338,
    minimum: 0.000337,
    maximum: 0.022214,
    standardDeviation: 0.004567,
    variance: 0.000021,
    percentile25: 0.000337,
    percentile75: 0.002222,
    iqr: 0.001885,
    lowerFence: -0.00249,
    upperFence: 0.00505,
    additionalStatistics: {
      coefficientOfVariation: 1.175,
      skewness: 2.567,
      kurtosis: 8.234
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 86,
      source: 'production_line_x42'
    }
  },
  // X43 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X43. 안전 SL-PA 결과값',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 92,
    sum: 451.2968,
    range: 5.0,
    mean: 4.9054,
    median: 5.0,
    minimum: 0.0,
    maximum: 5.0,
    standardDeviation: 0.234567,
    variance: 0.055021,
    percentile25: 5.0,
    percentile75: 5.0,
    iqr: 0.0,
    lowerFence: 5.0,
    upperFence: 5.0,
    additionalStatistics: {
      coefficientOfVariation: 0.048,
      skewness: -2.345,
      kurtosis: 5.678
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 92,
      source: 'production_line_x43'
    }
  },
  // X44 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X44. 안전성과 수준 평가',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 90,
    sum: 315.441,
    range: 3.0,
    mean: 3.5049,
    median: 4.0,
    minimum: 2.0,
    maximum: 5.0,
    standardDeviation: 0.456789,
    variance: 0.208656,
    percentile25: 3.0,
    percentile75: 5.0,
    iqr: 2.0,
    lowerFence: 0.0,
    upperFence: 8.0,
    additionalStatistics: {
      coefficientOfVariation: 0.13,
      skewness: 0.123,
      kurtosis: 2.456
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 90,
      source: 'production_line_x44'
    }
  },
  // X51 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X51. 건설폐기물 발생량',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 87,
    sum: 20.065593,
    range: 0.704088,
    mean: 0.230639,
    median: 0.156999,
    minimum: 0.0001,
    maximum: 0.704188,
    standardDeviation: 0.123456,
    variance: 0.015241,
    percentile25: 0.02844,
    percentile75: 0.401985,
    iqr: 0.373545,
    lowerFence: -0.53188,
    upperFence: 0.962303,
    additionalStatistics: {
      coefficientOfVariation: 0.535,
      skewness: 1.234,
      kurtosis: 4.567
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 87,
      source: 'production_line_x51'
    }
  },
  // X52 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X52. 환경성과 수준 평가',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 89,
    sum: 400.60965,
    range: 2.0,
    mean: 4.50685,
    median: 5.0,
    minimum: 3.0,
    maximum: 5.0,
    standardDeviation: 0.345678,
    variance: 0.119493,
    percentile25: 4.0,
    percentile75: 5.0,
    iqr: 1.0,
    lowerFence: 2.5,
    upperFence: 6.5,
    additionalStatistics: {
      coefficientOfVariation: 0.077,
      skewness: -0.234,
      kurtosis: 2.789
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 89,
      source: 'production_line_x52'
    }
  },
  // X61 데이터 (이미지 수치 그대로 - 높은 값)
  {
    kpiName: 'X61. 투입인력 생산성',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 120,
    sum: 284733.0,
    range: 5538.9515,
    mean: 2372.775,
    median: 1849.723,
    minimum: 261.3085,
    maximum: 5800.26,
    standardDeviation: 1234.5678,
    variance: 1524156.789,
    percentile25: 572.8489,
    percentile75: 4074.343,
    iqr: 3501.4941,
    lowerFence: -4679.39,
    upperFence: 9326.583,
    additionalStatistics: {
      coefficientOfVariation: 0.52,
      skewness: 1.234,
      kurtosis: 4.567
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 120,
      source: 'high_value_production_x61'
    }
  },
  // X62 데이터 (이미지 수치 그대로)
  {
    kpiName: 'X62. 생산성성과 수준 평가',
    valueDate: '2025-08',
    periodType: KpiPeriodType.MONTH,
    count: 95,
    sum: 393.87475,
    range: 2.0,
    mean: 4.14605,
    median: 4.0,
    minimum: 3.0,
    maximum: 5.0,
    standardDeviation: 0.456789,
    variance: 0.208656,
    percentile25: 4.0,
    percentile75: 4.0,
    iqr: 0.0,
    lowerFence: 4.0,
    upperFence: 4.0,
    additionalStatistics: {
      coefficientOfVariation: 0.11,
      skewness: 0.123,
      kurtosis: 2.456
    },
    metadata: {
      calculationMethod: 'automated',
      lastCalculated: '2025-01-15T10:30:00Z',
      dataCount: 95,
      source: 'production_line_x62'
    }
  }
]

export class AddKpiStatistics1752192090124 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<any> {
    const repository = getRepository(KpiStatistic)
    const kpiRepository = getRepository(Kpi)
    const domainRepository = getRepository(Domain)
    const domain = await domainRepository.findOneBy({ subdomain: 'system' })

    if (!domain) {
      throw new Error('SYSTEM domain not found')
    }

    // 통계 데이터를 실제 KPI와 연결하여 저장
    const statisticsToSave = []

    for (const statistic of KPI_STATISTICS) {
      try {
        // KPI 찾기
        const kpi = await kpiRepository.findOneBy({
          name: statistic.kpiName,
          domain: { id: domain.id }
        })

        if (!kpi) {
          console.log(`⚠️  KPI not found: ${statistic.kpiName}`)
          continue
        }

        // 통계 데이터에 KPI와 도메인 연결
        const statisticWithRelations = {
          ...statistic,
          kpi,
          domain
        }

        statisticsToSave.push(statisticWithRelations)
        console.log(`✅ Prepared statistic for KPI: ${statistic.kpiName}`)
      } catch (error) {
        console.error(`❌ Error preparing statistic for ${statistic.kpiName}:`, error)
      }
    }

    // 배치로 저장
    if (statisticsToSave.length > 0) {
      const batchSize = 5
      for (let i = 0; i < statisticsToSave.length; i += batchSize) {
        const batch = statisticsToSave.slice(i, i + batchSize)
        await repository.save(batch)
        console.log(`✅ Saved batch ${Math.floor(i / batchSize) + 1}/${Math.ceil(statisticsToSave.length / batchSize)}`)
      }
    }

    console.log(`🎉 Successfully saved ${statisticsToSave.length} KPI statistics`)
  }

  public async down(queryRunner: QueryRunner): Promise<any> {
    const repository = getRepository(KpiStatistic)
    const domainRepository = getRepository(Domain)
    const domain = await domainRepository.findOneBy({ subdomain: 'system' })

    if (!domain) {
      console.log('⚠️  SYSTEM domain not found. Nothing to delete.')
      return
    }

    const results = []
    for (const statistic of KPI_STATISTICS.reverse()) {
      try {
        const record = await repository.findOneBy({
          kpi: { name: statistic.kpiName },
          valueDate: statistic.valueDate,
          periodType: statistic.periodType as any,
          domain: { id: domain.id }
        })

        if (record) {
          await repository.remove(record)
          console.log(`✅ Deleted statistic for KPI: ${statistic.kpiName}`)
          results.push(statistic.kpiName)
        } else {
          console.log(`⚠️  Statistic not found for KPI: ${statistic.kpiName}`)
        }
      } catch (error) {
        console.error(`❌ Error deleting statistic for ${statistic.kpiName}:`, error)
      }
    }

    console.log(`🎉 Successfully deleted ${results.length} KPI statistics`)
    return results
  }
}
